/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowchannelinstagrampost4Inputs */

const en_aiflowchannelinstagrampost4 = /** @type {(inputs: Aiflowchannelinstagrampost4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instagram post`)
};

const de_aiflowchannelinstagrampost4 = /** @type {(inputs: Aiflowchannelinstagrampost4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instagram Beitrag`)
};

/**
* | output |
* | --- |
* | "Instagram post" |
*
* @param {Aiflowchannelinstagrampost4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowchannelinstagrampost4 = /** @type {((inputs?: Aiflowchannelinstagrampost4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowchannelinstagrampost4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowchannelinstagrampost4(inputs)
	return de_aiflowchannelinstagrampost4(inputs)
});
export { aiflowchannelinstagrampost4 as "aiFlowChannelInstagramPost" }